// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".31c5dc9bcc27b6977e99d759dddd92d364fbac54.chunk.js";
};